import { useMemo } from "react";

const FrameComponent = ({
  frameDivPosition,
  frameDivBorderRadius,
  frameDivWidth,
  frameDivHeight,
  frameDivBoxSizing,
  frameDivCursor,
  onAddButtonContainerClick,
}) => {
  const frameDivStyle = useMemo(() => {
    return {
      position: frameDivPosition,
      borderRadius: frameDivBorderRadius,
      width: frameDivWidth,
      height: frameDivHeight,
      boxSizing: frameDivBoxSizing,
      cursor: frameDivCursor,
    };
  }, [
    frameDivPosition,
    frameDivBorderRadius,
    frameDivWidth,
    frameDivHeight,
    frameDivBoxSizing,
    frameDivCursor,
  ]);

  return (
    <div
      className="relative rounded-21xl bg-gold flex flex-row py-[31px] px-8 items-center justify-center hover:bg-goldenrod-100 active:bg-darkkhaki"
      style={frameDivStyle}
      onClick={onAddButtonContainerClick}
    >
      <img className="relative w-7 h-7" alt="" src="/group-20.svg" />
    </div>
  );
};

export default FrameComponent;
